
import React, { useContext,  useRef} from 'react';

import styled from 'styled-components';


import { VscChevronLeft} from "react-icons/vsc";
import DetayLine from './DetayLine';

import DetayLineChoise from './DetayLineChoise';
import DetayLineNot from './DetayLineNot';
import { DilContext } from '../ContextDil';

const Background = styled.div`
  width: 100%;
  height: 100%;
  top:0;
  left:0;
 
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto; 
  background: #fff;
  z-index: 10;
`;

const ModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px;
  background: #fff;
  color: #000;
  min-height: 0;
  position: relative;
  z-index: 10;
 

`;



const ModalContent = styled.div`
  display: flex;
  
  
  
  flex-direction: column;
  justify-content: left;
  align-items: Left;
  line-height: 1.8;
  padding: 5px;
  color: #141414;
 
  
  

 
  
`;


const InfoPageTopSectionEl = styled.section`
  background-image: url(${props => props.background});
  background-size: cover;
  min-height: 250px;
  background-size: 1/1;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  
  transition: var(--transition);
  border-radius: 0.8rem;
  overflow: hidden;
  margin:0 0;

  
  flex:0;

  @media  (min-width: 768px){
    margin:0 8rem;
    min-height: 450px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  
  }
`;

const TopMenu = styled.span`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  width: 100%;
  position:fixed;
 
  color: whitesmoke;
  & > svg {
    font-size: 2rem;
    background-color: white;
    color:black;
    border-radius: 50%;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
    cursor: pointer;
  }
 
`;
const Title = styled.div`
  width: 100%;
  display: flex;

  flex:0;
  
  justify-content: space-between;
  padding: 2rem 0.2rem;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
`;
const TitleLeft = styled.span`
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  font-weight: bold;
  width:80%;
  line-height: 1;
`;
const TitleRight = styled.span`
  display: flex;
  flex-direction: column;
  width:20%;
  align-items: flex-end;
  text-align: right;
  font-size: 1.1rem;
  font-weight: bold;
  line-height: 1rem;
  color: red;
`;

const TabContent = styled.div`
  padding: 1rem 2rem;
  overflow: auto;
 flex:1;
  scrollbar-width: 0;
  ::-webkit-scrollbar {
    display: none;
  }
`;
const DetayModal = ({ id, res,resim,dataa, showModal, setShowModal }) => {
  const modalRef = useRef();
  const {lang} =useContext(DilContext);
  console.log(dataa);
  // console.log(res);
  // console.log(resim);

  // const data=[
  //   {"ID":"1","DETID":"0","DETDETID":"-1","PR_TR":"1","DESCRIPTION":"Extra Ürün Seçenekleri",
  //   "DESCRIPTION_ING":"Extra Product Options",
  //   "DETAIL":[{"ID":"10","DETID":"1","DETDETID":"0","PR_TR":"1","SUB_PRUDUCT_CODE":"URK0139",
  //   "DESCRIPTION":"Limonata","DESCRIPTION_ING":"Lemonade","PRICE":"0","UNIT":"ADET","QUANTITY":"0",
  //   "DISCOUNT":"0","MULTIPLIER":"0"},{"ID":"6","DETID":"1","DETDETID":"0","PR_TR":"1",
  //   "SUB_PRUDUCT_CODE":"URK0136","DESCRIPTION":"Fusetea",
  //   "DESCRIPTION_ING":"Fusetea","PRICE":"0","UNIT":"ADET","QUANTITY":"0","DISCOUNT":"0","MULTIPLIER":"0",
  //   "SUBDETAIL":[{"ID":"7","DETID":"6","DETDETID":"1","PR_TR":"1","SUB_PRUDUCT_CODE":"",
  //   "DESCRIPTION":"Portakal","DESCRIPTION_ING":"Orange","PRICE":"0","UNIT":"","QUANTITY":"0","DISCOUNT":"0",
  //   "MULTIPLIER":"0"},
  //   {"ID":"8","DETID":"6","DETDETID":"1","PR_TR":"1","SUB_PRUDUCT_CODE":"",
  //   "DESCRIPTION":"Limon","DESCRIPTION_ING":"Lemon","PRICE":"0","UNIT":"","QUANTITY":"0","DISCOUNT":"0",
  //   "MULTIPLIER":"0"},{"ID":"9","DETID":"6","DETDETID":"1","PR_TR":"1","SUB_PRUDUCT_CODE":"",
  //   "DESCRIPTION":"Mandalina","DESCRIPTION_ING":"Tangerine","PRICE":"0","UNIT":"","QUANTITY":"0",
  //   "DISCOUNT":"0","MULTIPLIER":"0"}]},{"ID":"5","DETID":"1","DETDETID":"0","PR_TR":"1",
  //   "SUB_PRUDUCT_CODE":"URK0133","DESCRIPTION":"Sprite","DESCRIPTION_ING":"Sprites","PRICE":"0",
  //   "UNIT":"ADET","QUANTITY":"0","DISCOUNT":"0","MULTIPLIER":"0"},{"ID":"2","DETID":"1",
  //   "DETDETID":"0","PR_TR":"1","SUB_PRUDUCT_CODE":"URK0130","DESCRIPTION":"Cola",
  //   "DESCRIPTION_ING":"Cola","PRICE":"0","UNIT":"ADET","QUANTITY":"0","DISCOUNT":"0","MULTIPLIER":"0",
  //   "SUBDETAIL":[{"ID":"3","DETID":"2","DETDETID":"1","PR_TR":"1",
  //   "SUB_PRUDUCT_CODE":"URK0131","DESCRIPTION":"Zero","DESCRIPTION_ING":"Zero",
  //   "PRICE":"0","UNIT":"ADET","QUANTITY":"0","DISCOUNT":"0","MULTIPLIER":"0"},{"ID":"4","DETID":"2",
  //   "DETDETID":"1","PR_TR":"1","SUB_PRUDUCT_CODE":"URK0132","DESCRIPTION":"Light",
  //   "DESCRIPTION_ING":"Light Table","PRICE":"0","UNIT":"ADET","QUANTITY":"0","DISCOUNT":"0","MULTIPLIER":"0"}]}]},
  //   {"ID":"11","DETID":"0","DETDETID":"-1","PR_TR":"2",
  //   "DESCRIPTION":"Ürün Porsiyon Seçenekleri",
  //   "DESCRIPTION_ING":"Product Portion Options",
  //   "DETAIL":[{"ID":"12","DETID":"11","DETDETID":"0","PR_TR":"2","SUB_PRUDUCT_CODE":"",
  //   "DESCRIPTION":"Duble","DESCRIPTION_ING":"Double","PRICE":"75","UNIT":"","QUANTITY":"0",
  //   "DISCOUNT":"0","MULTIPLIER":"0"},{"ID":"13","DETID":"11","DETDETID":"0","PR_TR":"2",
  //   "SUB_PRUDUCT_CODE":"","DESCRIPTION":"Yarım","DESCRIPTION_ING":"Half",
  //   "PRICE":"40","UNIT":"","QUANTITY":"0","DISCOUNT":"0","MULTIPLIER":"0"}]},
  //   {"ID":"14","DETID":"0","DETDETID":"-1","PR_TR":"6","DESCRIPTION":"Yanında Giden Ürünler",
  //   "DESCRIPTION_ING":"Products That Go With You","DETAIL":[{"ID":"15","DETID":"14","DETDETID":"0","PR_TR":"6",
  //   "SUB_PRUDUCT_CODE":"URK0165","DESCRIPTION":"Mimoza","DESCRIPTION_ING":"Mimosa","PRICE":"0","UNIT":"PRS",
  //   "QUANTITY":"0","DISCOUNT":"0","MULTIPLIER":"0"},{"ID":"16","DETID":"14","DETDETID":"0","PR_TR":"6",
  //   "SUB_PRUDUCT_CODE":"URK0205","DESCRIPTION":"Guınness 50 cc",
  //   "DESCRIPTION_ING":"Guinness 50 cc","PRICE":"0","UNIT":"ADET","QUANTITY":"0",
  //   "DISCOUNT":"0","MULTIPLIER":"0"},{"ID":"17","DETID":"14","DETDETID":"0","PR_TR":"6",
  //   "SUB_PRUDUCT_CODE":"URK0096","DESCRIPTION":"Frederik &İndia Paleale 35 cc",
  //   "DESCRIPTION_ING":"Frederik","PRICE":"0","UNIT":"ADET","QUANTITY":"0","DISCOUNT":"0",
  //   "MULTIPLIER":"0"},{"ID":"18","DETID":"14","DETDETID":"0","PR_TR":"6",
  //   "SUB_PRUDUCT_CODE":"URK0102","DESCRIPTION":"Tuborg Amber 50 cc",
  //   "DESCRIPTION_ING":"Tuborg Amber 50 cc","PRICE":"0","UNIT":"ADET",
  //   "QUANTITY":"0","DISCOUNT":"0","MULTIPLIER":"0"},{"ID":"19","DETID":"14","DETDETID":"0","PR_TR":"6",
  //   "SUB_PRUDUCT_CODE":"URK0100","DESCRIPTION":"Tuborg Gold 33 cc",
  //   "DESCRIPTION_ING":"Tuborg Gold 33 cc","PRICE":"0","UNIT":"ADET","QUANTITY":"0",
  //   "DISCOUNT":"0","MULTIPLIER":"0"},{"ID":"20","DETID":"14","DETDETID":"0","PR_TR":"6",
  //   "SUB_PRUDUCT_CODE":"URK0111","DESCRIPTION":"Grimbergen Blonde 33 cc",
  //   "DESCRIPTION_ING":"Grimbergen Blonde 33 cc","PRICE":"0","UNIT":"ADET","QUANTITY":"0",
  //   "DISCOUNT":"0","MULTIPLIER":"0"}]},
  //   {"ID":"31","DETID":"0","DETDETID":"-1","PR_TR":"5",
  //   "DESCRIPTION":"Ürün Notları","DESCRIPTION_ING":"Product Notes",
  //   "DETAIL":[{"ID":"32","DETID":"31","DETDETID":"0","PR_TR":"5","SUB_PRUDUCT_CODE":"",
  //   "DESCRIPTION":"Sert Pişmesin","DESCRIPTION_ING":"Don t Cook Hard","PRICE":"0","UNIT":"",
  //   "QUANTITY":"0","DISCOUNT":"0","MULTIPLIER":"0"}]}];

  return (
   
   <>

      {showModal ? (
        <Background ref={modalRef}>

          <ModalWrapper showModal={showModal}>
            <InfoPageTopSectionEl background={resim}>
              <TopMenu>
                <VscChevronLeft
                  onClick={() => setShowModal(false)}
                />

              </TopMenu>
            </InfoPageTopSectionEl>
            <Title>
            { (lang==="en") ?
              <TitleLeft>
                {res.URUN_ADI_ING}
              </TitleLeft>
             :
              <TitleLeft>
                {res.URUN_ADI}
              </TitleLeft>
}
              <TitleRight>{res.FIYATI} TL</TitleRight>
            </Title>
            {(lang === "en") ?
              <TabContent>{res.URUN_ACIKLAMA_DIL}</TabContent>
              :
              <TabContent>{res.URUN_ACIKLAMA}</TabContent>
            }

            {/* <ModalContent>
              {data && data.map((uresult, index) => (
               <div>{
                (() => {
                  if (uresult.PR_TR==="1") {
                    return (
                      <DetayLineChoise key={index} 
                      price={res.FIYATI} 
                      ack={(lang==='en') ? uresult.DESCRIPTION_ING : uresult.DESCRIPTION} 
                      data={uresult.DETAIL} />

                    )
                  } else if (uresult.PR_TR==="2") {
                    return (
                      <DetayLineNot key={index} 
                       ack={(lang==='en') ? uresult.DESCRIPTION_ING : uresult.DESCRIPTION}
                       data={data[index].DETAIL} />
                    )
                  } else if (uresult.PR_TR==="5") {
                      return (
                        <DetayLine key={index} data={uresult.DETAIL} />
                      )
                    } else {  
                    return (
                      <DetayLine key={index} data={uresult.DETAIL} />
                    )
                  }
                })()
              }
              </div>
               
                // (() => {
                //   switch (uresult.PR_TR) {
                //     case '2':
                //       return <DetayLineNot key={index} ack={uresult.ACIKLAMA} data={data[index].DETAY} />
                //     case '3':
                //       return <DetayLineChoise key={index} price={res.FIYATI} ack={uresult.ACIKLAMA} data={data[index].DETAY} />
                //     case '4':
                //       return <DetayLineNot key={index} ack={uresult.ACIKLAMA} data={data[index].DETAY} />
                //     case '1':
                //       return <DetayLine key={index} data={data[index].DETAY} />
                //     default:
                //       return null
                //   }
                // })()
            
              ))}
            </ModalContent> */}


          </ModalWrapper>

        </Background>
      ) : null}
    </>
  );
};
export default DetayModal;